import { resetLocalAndSessionStores } from 'helpers/resetLocalAndSessionStores'
import { useEffect } from 'react'
import { useShallow } from 'zustand/shallow'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandStore } from 'zustandGlobalStore'

export const useCleanDataByLeadIdChange = (): void => {
  const { leadId } = useZustandStore(
    useShallow((state) => ({
      leadId: state.lead?.id || '',
    })),
  )
  const { previousLeadId } = useZustandGlobalLocalStore(
    useShallow((state) => ({
      previousLeadId: state.previousLeadId,
    })),
  )

  useEffect(() => {
    const isLeadIdChanging =
      leadId && previousLeadId && leadId !== previousLeadId

    if (isLeadIdChanging) {
      resetLocalAndSessionStores()
      useZustandGlobalLocalStore.setState({
        previousLeadId: leadId,
      })
    }
  }, [leadId, previousLeadId])
}
